<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<span id="popover" [hidden]="!evidenceUserHelperAvailable">
    <div class="popover-close-cross" (click)="closePopover()">X</div>
    <img *ngIf="evidenceUserHelperImage" [src]="evidenceUserHelperImage"/>
    <h6 *ngIf="evidenceUserHelperText">{{ 'evidences.popover.note' | translate }} {{ evidenceUserHelperText | translate }}</h6>
</span>